import "../../styles/classification/cantSaveWarning.css";
export { CantSaveWarning };
type Props = {
  docType: string;
  modelName: string;
  startRuleCount: number;
};
const CantSaveWarning = ({ docType, modelName, startRuleCount }: Props) => {
  return (
    <span className={"cantSaveWarning"}>
      {docType !== "Unknown" &&
        modelName === "" &&
        startRuleCount > 0 &&
        "Cannot Save Template Without A Name"}
      {docType === "Unknown" &&
        modelName !== "" &&
        startRuleCount > 0 &&
        "Cannot Save Template With A DocType Of Unknown"}
    </span>
  );
};
